<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("AccountAds.ObjectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                  top_image = null;
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("AccountAds.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>

        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <!-- 标题 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("AccountAds.Fields.title") }}{{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('AccountAds.Fields.title')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="account_ad.top_title"
                      single-line
                      dense
                      hide-details
                      :hint="isNew ? '' : $t('AccountAds.titleHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'top_title')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ account_ad.top_title }}
                </v-col>
              </v-row>
              <!-- 内容 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("AccountAds.Fields.top_content")
                  }}{{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('AccountAds.Fields.top_content')"
                    rules="required"
                  >
                    <v-textarea
                      v-model="account_ad.top_content"
                      outlined
                      auto-grow
                      :hint="isNew ? '' : $t('AccountAds.contentHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'top_content')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ account_ad.top_content }}
                </v-col>
              </v-row>
              <!-- 是否置顶 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("AccountAds.Fields.top_sort") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-radio-group row v-model="account_ad.top_sort">
                    <v-radio
                      :label="$t('AccountAds.topSort.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('AccountAds.topSort.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <v-chip
                    small
                    label
                    dark
                    :color="account_ad.top_sort ? 'primary' : 'grey'"
                  >
                    {{
                      account_ad.top_sort == 1
                        ? $t("AccountAds.topSort.on")
                        : $t("AccountAds.topSort.off")
                    }}
                  </v-chip>
                </v-col>
              </v-row>
              <!-- 首页图片 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("AccountAds.Fields.img") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-card v-if="top_image" max-width="240">
                    <v-img
                      :src="top_image"
                      @click.stop="$showFullscreenImages([top_image])"
                    >
                      <v-tooltip right v-if="savable && top_image">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="secondary"
                            class="pa-2 float-right"
                            @click.stop="
                              !top_image.startsWith('data:image/') &&
                              top_image == account_ad.top_image
                                ? (account_ad.top_image = top_image = null)
                                : (top_image = null)
                            "
                          >
                            fa-times
                          </v-icon>
                        </template>
                        <span> {{ $t("Material.delImg") }}</span>
                      </v-tooltip>
                    </v-img>
                  </v-card>
                  <v-file-input
                    ref="top_image_file"
                    v-if="savable"
                    show-size
                    prepend-icon="fa-camera"
                    accept="image/png, image/jpeg"
                    persistent-hint
                    :placeholder="$t('Material.imgPlaceholder')"
                    :hint="$t('AccountAds.imgHint')"
                    :rules="imgRules"
                    v-model="top_image_file"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
              <!-- 公开/非公开 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("AccountAds.Fields.pub_flg") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-radio-group row v-model="account_ad.pub_flg">
                    <v-radio
                      :label="$t('AccountAds.pubFlg.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('AccountAds.pubFlg.off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <v-chip
                    small
                    label
                    dark
                    :color="account_ad.pub_flg ? 'primary' : 'grey'"
                  >
                    {{
                      account_ad.pub_flg == 1
                        ? $t("AccountAds.pubFlg.on")
                        : $t("AccountAds.pubFlg.off")
                    }}
                  </v-chip>
                </v-col>
              </v-row>
              <!-- 内容类型 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("AccountAds.Fields.detail_type") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-radio-group row v-model="account_ad.detail_type">
                    <v-radio
                      v-for="stat in contentType"
                      :key="stat.value"
                      :label="`${stat.text}`"
                      :value="stat.value"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <v-chip
                    small
                    label
                    dark
                    :color="account_ad.detail_type ? 'primary' : 'primary'"
                  >
                    {{ account_ad.detail_type | accountAdsTypesText }}
                  </v-chip>
                </v-col>
              </v-row>
              <!-- 页面详细内容 URL-->
              <v-row v-if="account_ad.detail_type == 1">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("AccountAds.Fields.URL") }}{{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <!-- <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('AccountAds.Fields.URL')"
                    rules="required"
                  > -->
                  <v-text-field
                    v-model="account_ad.url"
                    single-line
                    dense
                    hide-details
                  >
                    <!-- <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template> -->
                  </v-text-field>
                  <!-- </ValidationProvider> -->
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ account_ad.url }}
                </v-col>
              </v-row>
              <!-- 页面详细内容 富文本 -->
              <v-row v-show="account_ad.detail_type == 2">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("AccountAds.Fields.detail") + $t("Global.colon") }}
                  <Required :show="false" :mode="mode" />
                </v-col>
                <v-col cols="9" v-show="savable">
                  <VEditor v-model="account_ad.page" />
                </v-col>
                <v-col cols="9" v-show="!savable && account_ad.page">
                  <v-card-text
                    outlined
                    class="pa-1 accountAd-img"
                    id="accountAdPage"
                  >
                  </v-card-text>
                </v-col>
              </v-row>
              <!-- 页面详细内容 URL-->
              <v-row v-if="account_ad.detail_type == 3">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("AccountAds.Fields.broadcastID")
                  }}{{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('AccountAds.Fields.broadcastID')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="account_ad.broadcast_id"
                      single-line
                      dense
                      hide-details
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'broadcast_id')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ account_ad.broadcast_id }}
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                outlined
                color="secondary"
                class="elevatio-1"
                block
                @click="
                  $emit('input', null);
                  $emit('mode', null);
                  top_image = null;
                "
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.backToList", [$t("AccountAds.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="isView">
              <v-btn
                color="accent"
                block
                :disabled="loading && !account_ad.id"
                @click="$emit('mode', 'edit')"
              >
                <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                {{ $t("CRUD.editInfo", [$t("AccountAds.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="savable">
              <!-- 保存 -->
              <v-btn
                color="success"
                block
                :disabled="loading && !account_ad.id"
                @click="save()"
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.saveInfo", [$t("AccountAds.ObjectName")]) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>
<style>
.accountAd-img {
  width: 50% !important;
}
.accountAd-img p {
  margin: 0;
}
.accountAd-img p img {
  width: 100% !important;
  height: 100% !important;
}
</style>
<script>
import { mapState } from "vuex";
import Consts from "@/consts.js";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import AccountAds from "@/api/account_ads";
import Required from "@/components/plugins/Required";
import Files from "@/api/files";
import i18n from "@/i18n";
import VEditor from "@/plugins/VEditor";

export default {
  props: ["value", "mode"],

  components: {
    Required,
    VEditor,
    ValidationObserver,
    ValidationProvider,
  },

  data: () => ({
    account_ad: {},
    serverErrors: [],
    top_image: "",
    top_image_file: null,
    imgRules: [
      (value) =>
        !value || value.size < 10000000 || i18n.t("AccountAds.imgHint"),
    ],
  }),

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    contentType() {
      return Consts.account_ads.content_type;
    },
    ...mapState(["loading"]),
  },

  methods: {
    save() {
      this.$store.dispatch("fullscreenLoading");
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.top_image_file.hasError) return;
      this.serverErrors = []; //重置远端错误提示

      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            //   先 图片
            if (this.top_image_file) {
              let response = await Files.imageUpload(
                this.top_image_file,
                true,
                "news"
              );
              if (response.data.status.isOK()) {
                this.account_ad.top_image = response.data.data.img_name;
                this.account_ad.thumbnail = response.data.data.thumbnail;
              }
            }
            var account_ad = JSON.parse(JSON.stringify(this.account_ad));
            AccountAds.save(account_ad.id, account_ad)
              .then(
                function (response) {
                  var accountaddata = JSON.parse(
                    JSON.stringify(response.data.account_ad)
                  );
                  if (response.data.status.isOK()) {
                    this.$emit("save", this.account_ad);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                    if (this.mode == "new") {
                      this.$router.replace(
                        "/account-ads/push-to-shop/" + accountaddata.id
                      );
                    }
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          AccountAds.fetchOne(this.value.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.account_ad = response.data.account_ad;
              }
            }.bind(this)
          );
        } else {
          // 新建，初始化默认值
          this.account_ad = {
            top_sort: 0,
            pub_flg: 0,
            detail_type: 2,
          };
        }
        this.$scrollTop(); //返回顶部
      },
    },

    account_ad: {
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.account_ad.top_image) {
          this.top_image = this.account_ad.top_image;
          this.top_image_file = null;
        }
        var node = null;
        node = document.getElementById("accountAdPage");
        if (node)
          node.childNodes.forEach((child) => {
            node.removeChild(child);
          });
        if (this.account_ad.page) {
          node = document.getElementById("accountAdPage");
          if (node)
            node.append(
              new DOMParser().parseFromString(this.account_ad.page, "text/html")
                .body.childNodes[0]
            );
        }
      },
    },

    top_image: {
      handler() {
        if (!this.top_image) {
          this.top_image_file = null;
        }
      },
    },

    top_image_file: {
      handler() {
        if (this.top_image_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.top_image_file);
          let that = this;
          reader.onload = function () {
            that.top_image = this.result;
          };
        } else {
          this.top_image = this.account_ad.top_image;
        }
      },
    },
  },
};
</script>

<style>
</style>